import {v4 as uuidv4} from 'uuid';
import axios from 'axios';
import {apiClient} from '../apiClient';
import BASE_URL from '../../config/env';

export interface LoginRequest {
  userEmailID: string;
  ipAddress: string;
}

export interface LoginResponse {
  userId: number;
  baseRoleId: number;
  roleId: number;
  entityId: number;
  projectId: number;
  securityGroupId: number;
  landingPage: string;
  token: string;
  uuid?: string;
  roleName?: string;
  firstName?: string;
  lastName?: string;
  emailID?: string;
  userName?: string;
}

export const getUUID = (): string => {
  let existing = localStorage.getItem('dev-session-id');
  if (!existing) {
    existing = uuidv4();
    localStorage.setItem('dev-session-id', existing);
  }
  return existing;
};

export const getPublicIP = async (): Promise<string> => {
  const {data} = await axios.get<{ip: string}>(
    'https://api.ipify.org?format=json'
  );
  return data.ip;
};
const loginEndpoint = (path: string) =>
  `${BASE_URL}/usermanagement/api/v1/login${path}`;

const logoutSSOEndpoint = () =>
  `${BASE_URL}/usermanagement/api/v1/login/ssologout`;

export const logoutOtherSession = async (email: string) => {
  const {data} = await apiClient.get(
    loginEndpoint(`/logoutothersession?login_hint=${email}`)
  );
  return data;
};

export const logoutSSO = async () => {
  const {data} = await apiClient.get(logoutSSOEndpoint());
  return data;
};
